import { ReactQueryProvider } from './blocks-renderers'
import { AppComponent } from './components/AppComponent'
import { AppManager } from './components/AppManager'
import { ConfigCheckWrapper } from './components/ConfigCheckWrapper'
import { useAppParams } from './hooks/useAppParams/useAppParams'
import { AppStoreProvider } from './providers/AppStore'

export const AppShell = () => {
  const appParams = useAppParams()

  return (
    <ConfigCheckWrapper appParams={appParams}>
      <ReactQueryProvider>
        <AppStoreProvider>
          <AppManager appParams={appParams}>
            <AppComponent />
          </AppManager>
        </AppStoreProvider>
      </ReactQueryProvider>
    </ConfigCheckWrapper>
  )
}

AppShell.displayName = 'AppShell'

export default AppShell // for lazy loading
